define([
  /* eslint-disable */
  'js/aofl-js/0.8.0/app/app',
  'js/cdn-asset-service/1.0.0/index-impl'
  /* eslint-enable */
], function service(app, cdnAssetServiceImpl) {
  'use strict';

  app.registerService('cdnAssetService', [cdnAssetServiceImpl]);
});
